import React, { useState } from "react";

// Custom Components
import PublicPage from '@/ui/PublicPage/PublicPage'
import PublicMap from "@/views/GIS/MapPage/PublicMap";
import WelcomeModalDialog from "./WelcomeModalDialog";
import MapRoutingProvider from "@/components/MapRoutingContext/MapRoutingProvider";

function PublicHomePage() {

  const [showWelcome, setShowWelcome] = useState(true);

  const dontShowAgain = localStorage.getItem("welcome_dont_show");

  const handleCloseModal = () => {
    setShowWelcome(false);
  }

  return (
    <PublicPage>
      <MapRoutingProvider>
        <PublicMap />
      </MapRoutingProvider>
      {showWelcome && dontShowAgain !== "true" ?
        <WelcomeModalDialog onClose={handleCloseModal} />
        : null}
    </PublicPage>
  );
}

export default PublicHomePage;